import styled from 'styled-components';

import { colors } from 'constants/colors';

import {
    GetMicrostoreProductsQuery,
    ManualReassortInstructionFragmentFragment,
    SetupInstructionType,
} from 'data/__generated__';

import { SETUP_INSTRUCTION_TYPE_LABELS } from 'pages/SiteSetups/constants/types';

// Read-only view of the products the delivery person restocked manually from the truck.
export const ManualReassortSection = ({
    instruction,
    products,
}: {
    instruction: ManualReassortInstructionFragmentFragment;
    products: GetMicrostoreProductsQuery['getMicrostoreProducts'];
}) => {
    const productsById = new Map(products.map((product) => [product._id, product]));

    return (
        <Container>
            <Title>{SETUP_INSTRUCTION_TYPE_LABELS[SetupInstructionType.ManualReassort]}</Title>
            {instruction.entries.length === 0 ? (
                <EmptyState>Aucun produit réapprovisionné depuis le camion.</EmptyState>
            ) : (
                <List>
                    {instruction.entries.map((entry) => (
                        <Row key={entry._id}>
                            <ProductName>{productsById.get(entry.productId)?.name ?? entry.productId}</ProductName>
                            <Quantity>×{entry.quantity}</Quantity>
                        </Row>
                    ))}
                </List>
            )}
        </Container>
    );
};

const Container = styled.div``;

const Title = styled.div`
    font-size: 18px;
    font-weight: bold;
    text-align: center;
`;

const EmptyState = styled.div`
    margin-top: 15px;
    text-align: center;
    color: ${colors.darkGrey};
`;

const List = styled.div`
    margin-top: 15px;
    & > :not(:first-child) {
        border-top: 1px solid ${colors.lightGrey};
        margin-top: 8px;
        padding-top: 8px;
    }
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ProductName = styled.div`
    font-weight: bold;
`;

const Quantity = styled.div`
    font-weight: bold;
    margin-left: 12px;
`;
